import { render } from "./FundByCheck.vue?vue&type=template&id=066d0673&scoped=true"
import script from "./FundByCheck.vue?vue&type=script&lang=js"
export * from "./FundByCheck.vue?vue&type=script&lang=js"

import "./FundByCheck.vue?vue&type=style&index=0&id=066d0673&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066d0673"]])

export default __exports__